export const Like = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={11} fill="none">
    <path
      fill="currentColor"
      d="M6.372 10.944c-.204.074-.54.074-.744 0C3.888 10.333 0 7.78 0 3.454 0 1.544 1.494 0 3.336 0 4.428 0 5.394.544 6 1.384A3.288 3.288 0 0 1 8.664 0C10.506 0 12 1.545 12 3.454c0 4.326-3.888 6.879-5.628 7.49Z"
    />
  </svg>
)

export const Paper = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={16} fill="none">
    <mask
      id="a"
      width={6}
      height={5}
      x={9}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fill="#9AD14B"
        d="M12.519 3.264c1.274.522 2.066 1.534 1.768 2.26-.043.105-.185.087-.242-.011-.327-.56-.991-1.11-1.85-1.462-.86-.352-1.719-.428-2.345-.259-.108.03-.22-.057-.178-.16.298-.726 1.572-.89 2.847-.368Z"
      />
      <path
        fill="#9AD14B"
        d="M13.12 1.572a.943.943 0 1 1 1.405 1.244l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#9AD14B"
        d="M12.519 3.264c1.274.523 2.066 1.534 1.768 2.26-.043.105-.185.086-.242-.011-.328-.56-.992-1.11-1.85-1.462-.86-.352-1.718-.427-2.345-.258-.108.029-.22-.057-.178-.162.298-.725 1.572-.89 2.847-.367Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M12.519 3.264c1.274.523 2.066 1.534 1.768 2.26-.043.105-.185.086-.242-.011-.328-.56-.992-1.11-1.85-1.462-.86-.352-1.718-.427-2.345-.258-.108.029-.22-.057-.178-.162.298-.725 1.572-.89 2.847-.367Z"
      />
      <path
        fill="#9AD14B"
        d="M13.12 1.571a.943.943 0 1 1 1.405 1.245l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M13.12 1.571a.943.943 0 1 1 1.405 1.245l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
      <ellipse
        cx={11.171}
        cy={4.261}
        fill="#9AD14B"
        rx={2.494}
        ry={1.42}
        transform="rotate(19.561 11.171 4.261)"
      />
      <path
        fill="#9AD14B"
        d="M12.31 1.304a.943.943 0 1 1 1.464 1.177l-1.582 1.652a4.867 4.867 0 0 0-1.437-.507l1.555-2.322Z"
      />
    </g>
    <mask
      id="b"
      width={14}
      height={12}
      x={0}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fill="#FF4E1F"
        d="M10.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#FF4E1F"
        d="M10.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M10.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
      <path
        fill="#FF4E1F"
        d="M9.453 3.331c-.67.143-1.198.428-1.647.896-.542.563-.709 1.031-.856 2.334-.214 1.894-.877 3.57-1.827 4.615-.622.685-1.566 1.215-2.523 1.418-.629.136-1.76.13-2.503-.006-.629-.116-.783-.082-.783.183 0 .244 1.178 1.052 2.202 1.5 3.052 1.357 6.933-.02 9.757-3.462.843-1.031 1.198-1.567 1.552-2.327.348-.74.476-1.249.476-1.934 0-.658-.155-1.229-.462-1.717-.703-1.1-2.168-1.751-3.386-1.5Z"
      />
    </g>
    <mask
      id="c"
      width={6}
      height={5}
      x={17}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fill="#9AD14B"
        d="M20.519 3.264c1.274.522 2.066 1.534 1.769 2.26-.044.105-.186.087-.243-.011-.327-.56-.991-1.11-1.85-1.462-.86-.352-1.718-.428-2.345-.259-.108.03-.22-.057-.178-.16.298-.726 1.572-.89 2.847-.368Z"
      />
      <path
        fill="#9AD14B"
        d="M21.12 1.572a.943.943 0 1 1 1.405 1.244l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#9AD14B"
        d="M20.519 3.264c1.274.523 2.066 1.534 1.769 2.26-.044.105-.186.086-.243-.011-.328-.56-.992-1.11-1.85-1.462-.86-.352-1.718-.427-2.345-.258-.108.029-.22-.057-.178-.162.298-.725 1.572-.89 2.847-.367Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M20.519 3.264c1.274.523 2.066 1.534 1.769 2.26-.044.105-.186.086-.243-.011-.328-.56-.992-1.11-1.85-1.462-.86-.352-1.718-.427-2.345-.258-.108.029-.22-.057-.178-.162.298-.725 1.572-.89 2.847-.367Z"
      />
      <path
        fill="#9AD14B"
        d="M21.12 1.571a.943.943 0 1 1 1.405 1.245l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M21.12 1.571a.943.943 0 1 1 1.405 1.245l-1.659 1.575a4.863 4.863 0 0 0-1.41-.575l1.663-2.244Z"
      />
      <ellipse
        cx={19.172}
        cy={4.261}
        fill="#9AD14B"
        rx={2.494}
        ry={1.42}
        transform="rotate(19.561 19.172 4.261)"
      />
      <path
        fill="#9AD14B"
        d="M20.31 1.304a.943.943 0 1 1 1.464 1.177l-1.582 1.652a4.867 4.867 0 0 0-1.437-.507l1.555-2.322Z"
      />
    </g>
    <mask
      id="d"
      width={14}
      height={12}
      x={8}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fill="#FF4E1F"
        d="M18.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fill="#FF4E1F"
        d="M18.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M18.138 4.153c-.669.142-1.198.427-1.646.895-.542.564-.71 1.032-.857 2.335-.214 1.893-.876 3.57-1.826 4.615-.623.685-1.566 1.214-2.523 1.418-.63.136-1.76.129-2.503-.007-.63-.115-.783-.081-.783.183 0 .244 1.178 1.052 2.202 1.5 3.051 1.357 6.932-.02 9.756-3.461.844-1.031 1.198-1.568 1.553-2.328.348-.74.475-1.248.475-1.934 0-.658-.154-1.228-.462-1.717-.702-1.099-2.168-1.75-3.386-1.5Z"
      />
      <path
        fill="#FF4E1F"
        d="M17.453 3.331c-.67.143-1.198.428-1.647.896-.542.563-.709 1.031-.856 2.334-.214 1.894-.877 3.57-1.827 4.615-.622.685-1.566 1.215-2.523 1.418-.629.136-1.76.13-2.503-.006-.629-.116-.783-.082-.783.183 0 .244 1.178 1.052 2.202 1.5 3.052 1.357 6.933-.02 9.757-3.462.843-1.031 1.198-1.567 1.552-2.327.348-.74.476-1.249.476-1.934 0-.658-.154-1.229-.462-1.717-.703-1.1-2.168-1.751-3.386-1.5Z"
      />
    </g>
  </svg>
)

export const Leaf = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} fill="none">
    <path
      fill="#A6DD2F"
      d="M13.479.895c-.088-.283-.272-.42-.543-.407a4.176 4.176 0 0 0-.544.1c-2.481.593-5.051 2.494-7.13 5.275C4.56 6.8 4.155 7.42 3.528 8.512c-.216.382-.394.683-.394.67.003-.081.336-.959.54-1.43a16.036 16.036 0 0 1 2.94-4.52c.155-.165.517-.515.805-.776l.523-.473-.036-.076c-.058-.115-.33-.396-.55-.568C6.908.99 6.162.697 5.681.679c-.81-.03-1.93.545-2.818 1.44C2 2.993 1.347 4.019.879 5.234.608 5.94.447 6.546.304 7.403c-.071.438-.132 1.798-.1 2.248.078 1.04.223 1.863.497 2.8.188.641.531 1.586.579 1.588.01 0 .056-.053.104-.118a2.3 2.3 0 0 1 .282-.295c.448-.392 1.078-.745 2.43-1.355 1.851-.835 2.49-1.152 3.34-1.655 1.196-.71 2.185-1.533 2.929-2.44.4-.486.827-1.187.999-1.638.152-.403.211-.702.212-1.101.002-.559-.129-.964-.448-1.383-.411-.541-1.145-.97-1.747-1.02-.09-.008-.163-.02-.163-.03.001-.03.45-.337.746-.51a5.1 5.1 0 0 1 1.717-.639c.136-.023.513-.064.837-.09.324-.028.628-.06.671-.072.1-.028.256-.185.293-.297a.982.982 0 0 0-.003-.501Z"
    />
  </svg>
)

export const Info = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 18.333c4.584 0 8.334-3.75 8.334-8.333S14.584 1.667 10 1.667c-4.583 0-8.333 3.75-8.333 8.333s3.75 8.333 8.333 8.333ZM10 6.667v4.166"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.995 13.333h.008"
    />
  </svg>
)

export const Info2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-7 4.025a.525.525 0 0 0 .525-.525V6.3a.525.525 0 1 0-1.05 0v4.2c0 .29.235.525.525.525ZM7 3.5a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4Z"
      clipRule="evenodd"
    />
  </svg>
)

export const InfoRed = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" 
      stroke="#F5431D" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M12 8V13" 
      stroke="#F5431D" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M11.9941 16H12.0031" 
      stroke="#F5431D" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
)

export const Back = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none">
    <path
      fill="currentColor"
      d="M5.342 10.184.703 5.545 5.342.907l.895.885L3.13 4.899h7.805v1.293H3.13l3.107 3.102-.895.89Z"
    />
  </svg>
)

export const Edit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.333 1.333H6C2.666 1.333 1.333 2.667 1.333 6v4c0 3.334 1.333 4.667 4.667 4.667h4c3.333 0 4.666-1.333 4.666-4.667V8.667"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M10.693 2.013 5.44 7.267c-.2.2-.4.593-.44.88l-.287 2.006c-.106.727.407 1.234 1.134 1.134L7.853 11c.28-.04.674-.24.88-.44l5.254-5.253c.906-.907 1.333-1.96 0-3.294-1.334-1.333-2.387-.906-3.294 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M9.94 2.767a4.763 4.763 0 0 0 3.294 3.293"
    />
  </svg>
)

export const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none">
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      d="M7 4.75v2.497L8.5 8.5"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      d="M1 7a6 6 0 1 1 12 0c0 1.92-.905 3.637-2.308 4.735h-.009A5.947 5.947 0 0 1 7 13a5.948 5.948 0 0 1-3.655-1.246h-.01A5.987 5.987 0 0 1 1 7Z"
    />
  </svg>
)

export const Delivery = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={17} fill="none">
    <path
      fill="currentColor"
      d="M6.898 3.7a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2ZM4.19 8.757l.528-3.171a1.3 1.3 0 0 1 2.581.213v.074c0 1.264-.174 2.521-.518 3.736a.83.83 0 0 0 .144.743l.355.443c.471.588.864 1.235 1.17 1.923l1.18 2.657a.8.8 0 0 1-1.462.65l-1.18-2.657a7.2 7.2 0 0 0-.87-1.46l-.039-.052-.049-.062-.28-.35a14 14 0 0 0-1-1.11 2 2 0 0 1-.404-.541 1.7 1.7 0 0 1-.156-1.036Zm-2.17 7.584a.82.82 0 0 1-.086-1.164c.686-.794 1.828-2.22 2.425-3.541.071-.158.277-.201.396-.077.232.242.575.617.826.966a.35.35 0 0 1 .03.364c-.487.954-1.789 2.527-2.51 3.367a.77.77 0 0 1-1.082.085Zm6.085-9.859c.014-.16.205-.238.332-.139.62.485.922.553 1.662.56a.8.8 0 0 1 .567 1.366.81.81 0 0 1-.567.241c-.744.008-1.326-.03-1.897-.461a.53.53 0 0 1-.196-.48l.1-1.087ZM3.48 4.79 1.948 4.6a.5.5 0 0 0-.55.39L.489 9.105a.5.5 0 0 0 .427.604l1.533.19a.5.5 0 0 0 .55-.389l.91-4.116a.5.5 0 0 0-.427-.604Z"
    />
    <path stroke="currentColor" strokeLinecap="round" d="M7.697 1.5h1" />
    <path fill="currentColor" d="M5.398 1.5a1.5 1.5 0 1 1 3 0h-3Z" />
  </svg>
)

export const Restoran = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={15} fill="none">
    <path
      fill="currentColor"
      d="M11.5.127c-.438 0-3.5.875-3.5 4.813v3.062c0 .966.785 1.75 1.75 1.75h.875v3.5a.874.874 0 1 0 1.75 0V1.002A.874.874 0 0 0 11.5.127ZM1.875.565A.436.436 0 0 0 1.484.13a.435.435 0 0 0-.473.34L.182 4.195a2.407 2.407 0 0 0 2.13 2.92v6.136a.874.874 0 1 0 1.75 0V7.116a2.408 2.408 0 0 0 2.13-2.92L5.365.47A.438.438 0 0 0 4.5.565v3.67a.268.268 0 0 1-.536.021L3.622.526a.435.435 0 0 0-.435-.399.435.435 0 0 0-.434.4l-.34 3.73a.268.268 0 0 1-.536-.022L1.876.564Zm1.32 4.156H3.18l.008-.019.009.02Z"
    />
  </svg>
)

export const Table = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
    <rect x="2.5" y="5.5" width="11" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" d="M5 5.5V4M11 5.5V4M5 10.5V12M11 10.5V12" />
  </svg>
)

export const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={9} height={6} fill="none">
    <path stroke="#000" strokeLinecap="round" d="m1 1 3.5 3.5L8 1" />
  </svg>
)

export const Bubbles = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={27} fill="none">
    <circle cx={8} cy={19} r={8} fill="#fff" filter="drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15))" />
    <circle cx={12.5} cy={4.5} r={4.5} fill="#fff" filter="drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15))" />
  </svg>
)

export const Menu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.966 3.48 3.486 1l-2.48 2.48M3.486 13V1M8.033 10.52l2.48 2.48 2.48-2.48M10.513 1v12"
    />
  </svg>
)

export const Search = () => (
  <svg className="flex-none" xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M9.584 17.5a7.917 7.917 0 1 0 0-15.833 7.917 7.917 0 0 0 0 15.833ZM18.334 18.333l-1.667-1.666"
    />
  </svg>
)

export const Bag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.042}
      d="M7.083 11.875A2.93 2.93 0 0 0 10 14.792a2.93 2.93 0 0 0 2.916-2.917M7.342 1.667 4.325 4.692M12.658 1.667l3.017 3.025"
    />
    <path
      stroke="#fff"
      strokeWidth={1.042}
      d="M1.667 6.542c0-1.542.825-1.667 1.85-1.667h12.967c1.025 0 1.85.125 1.85 1.667 0 1.791-.825 1.666-1.85 1.666H3.517c-1.025 0-1.85.125-1.85-1.666Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.042}
      d="m2.917 8.333 1.175 7.2c.267 1.617.908 2.8 3.292 2.8h5.025c2.591 0 2.975-1.133 3.275-2.7l1.4-7.3"
    />
  </svg>
)

export const Close = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none">
    <path stroke="currentColor" strokeLinecap="round" d="m1 1 10 10M11 1 1 11" />
  </svg>
)

export const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={10}
    fill="none"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M1 1h12M1 5h8M1 9h12"
    />
  </svg>
)

export const Coin = () => (
  <svg
    version="1.1"
    id="Слой_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 35 35"
    style={{ enableBackground: "new 0 0 35 35" }}
    xmlSpace="preserve"
  >
    <style type="text/css">
      {`
        .st0{clip-path:url(#SVGID_00000062874934162995387780000000730221525655507387_);}
        .st1{fill:#5A91FF;}
        .st2{fill:#FFFFFF;fill-opacity:7.000000e-02;}
        .st3{fill:#F8B671;}
        .st4{fill-opacity:0.2;}
        .st5{fill:#FFFFFF;}
        .st6{fill:#EA6120;}
      `}
    </style>
    <g>
      <defs>
        <path
          id="SVGID_1_"
          d="M17.5,0L17.5,0C27.2,0,35,7.8,35,17.5l0,0C35,27.2,27.2,35,17.5,35l0,0C7.8,35,0,27.2,0,17.5l0,0 C0,7.8,7.8,0,17.5,0z"
        />
      </defs>
      <clipPath id="SVGID_00000047029970946664870230000008114448591197595035_">
        <use xlinkHref="#SVGID_1_" style={{ overflow: "visible" }} />
      </clipPath>
      <g style={{ clipPath: "url(#SVGID_00000047029970946664870230000008114448591197595035_)" }}>
        <path
          className="st1"
          d="M17.5,0L17.5,0C27.2,0,35,7.8,35,17.5l0,0C35,27.2,27.2,35,17.5,35l0,0C7.8,35,0,27.2,0,17.5l0,0 C0,7.8,7.8,0,17.5,0z"
        />
        <path
          className="st2"
          d="M56.9-5.5h3.9c0.5,1.8,1.4,3.4,2.7,4.8c0.6,0.7,1.3,1.3,2,1.9c1.6,1.4,3.2,2.9,5.1,3.9 c1.3,0.7,2.7,1.2,4.3,0.8C76.2,5.6,77.1,4.8,78,4c1.2-1.2,2.1-2.5,3.3-3.7c1.4-1.5,3.1-2.3,5.2-2.5c1.3-0.1,2.7-0.1,4-0.1 c2.2-0.1,3.9-1,4.8-3.1h2.6c-1,3.2-3,5.4-6.1,6.7c-1.8,0.7-3.6,1.1-5.4,1.7c-1.6,0.6-2.9,1.4-3.6,3c-0.5,1.2-0.5,2.5-0.3,3.8 c0.1,0.9,0.1,1.7-0.1,2.5c-0.2,0.8-0.5,1.7-0.8,2.5c-0.6,1.6-0.7,3.3-0.1,4.9c0.2,0.4,0.3,0.9,0.5,1.3c0.6,1.7,1,3.4,0.6,5.2 c-0.3,1.5-0.9,2.9-1.6,4.3c-1.3,2.7-2.6,5.4-3.3,8.3c-0.5,2.3-0.7,4.6,0.5,6.8c0.7,1.4,1.8,2.5,3,3.5c1.9,1.6,4.1,2.5,6.6,2.5 c1.6,0,3.2,0,4.7,0.1c1.9,0.2,3.7,0.7,5.2,1.9c1.5,1.2,2.6,2.8,3.5,4.6c0.7,1.4,1.2,2.8,2,4.1c1.1,1.7,2.6,2.7,4.7,2.6 c1.8-0.1,3.6-0.4,5.4-0.9c3.2-0.8,6.2-1.9,9.4-2.6c3.1-0.7,6.2-1,9.3,0.2c0.2,0.1,0.3,0.1,0.5,0.1v2.4c-2.1,0-4.2,0.4-6.2,1.2 c-1.7,0.7-3.3,1.4-4.9,2.3c-3.6,1.9-7.3,2.7-11.4,2c-3.5-0.6-6.3-2.2-8-5.4c-0.6-1.2-1.3-2.4-2-3.6c-1.4-2.4-3.4-4-6.2-4.4 c-1.1-0.1-2.1-0.2-3.2-0.3c-3-0.3-5.8-1.1-8.2-2.9c-0.9-0.7-1.6-1.6-2.5-2.4c-2.1-2-4.7-2.4-7.3-1.3c-1.4,0.6-2.7,1.5-4,2.2 c-2.3,1.3-4.7,1.6-7.2,0.8c-1.4-0.5-2.8-1.2-4-1.9c-0.8-0.5-1.7-1-2.6-1.3c-1.4-0.4-2.5,0-3.3,1.1c-0.3,0.5-0.6,1-1,1.5 c-1.4,2.1-2.5,2.5-4.8,1.4c-1-0.5-2-1-3-1.5c-1.3-0.6-2.6-0.6-3.9-0.1c-1.1,0.5-2.1,1-3,1.8c-1.8,1.6-3.8,2.6-6.1,3.4 c-1.7,0.6-3.4,1.1-5,1.9c-1.4,0.7-2.5,1.7-3,3.2c-0.3,0.9-0.1,1.6,0.6,2.2c0.3,0.3,0.7,0.5,1.1,0.7c1,0.5,2,0.8,3.1,1.2 c2.9,0.9,5.9,1.4,8.7,2.3c2.1,0.7,4.3,1.3,6.6,1.5c2.6,0.3,5.1,0.1,7.6-1.1c1.8-0.9,3.6-1.9,5.2-3c1.6-1.1,3.4-1.4,5.3-1 c1,0.2,1.9,0.5,2.8,1c2.8,1.4,5.7,1.8,8.7,1.2c1.8-0.4,3.6-0.5,5.4-0.3c2.2,0.3,4,1.1,5.3,2.9c1.6,2.2,3,4.5,4.1,7 c0.4,0.9,0.7,1.8,0.8,2.8h-1.9c-0.2-3.9-2.1-6.5-5.8-7.8c-2.1-0.7-4.2-1-6.3-1c-1.3,0-2.5,0-3.8-0.2c-2.2-0.3-4.4-0.9-6.2-2.2 c-1.8-1.3-3.7-1.3-5.7-0.3c-0.7,0.4-1.5,0.8-2.1,1.3c-2.5,2-5.3,3.5-8.3,4.7c-1.6,0.7-3.2,1.3-4.7,2.2c-1.3,0.8-2.5,1.6-2.9,3.2 h-2.8c0-1,0-2-0.3-3c-0.6-1.9-1.8-2.7-3.8-2.3c-0.8,0.2-1.6,0.4-2.4,0.6c-1.8,0.4-3-0.3-3.7-1.9c-0.3-0.7-0.4-1.4-0.6-2.1 c-0.3-1.3-1.2-2.1-2.5-2.3c-0.7-0.1-1.3-0.1-2,0c-1.1,0.2-2.1,0.6-3.1,0.9c-1.1,0.3-2.1,0.6-3.2,0.6c-2.1-0.1-3.7-1-4.6-3 c-0.2-0.5-0.4-0.9-0.6-1.4c-0.8-1.9-2.3-2.8-4.3-3.1c-2.4-0.3-4.8,0-7.1,0.7v-4.6c1.7-0.7,3.5-1,5.4-0.6c1.3,0.3,2.5,0.7,3.7,1.2 c2.5,0.9,5.1,1.5,7.7,0.8c4-1.1,7.7-2.8,10.8-5.5c1.8-1.5,3.3-3.2,5.3-4.5c2.2-1.4,4.4-2.5,7.1-2.8c1.5-0.2,3.1-0.2,4.6-0.5 c2.7-0.5,5.2-1.5,7.1-3.6c1.8-2,2-4.5,0.7-6.8c-1.5-2.7-3.7-4.4-6.8-4.8c-1.8-0.2-3.6-0.7-5.3-1.4c-1.3-0.5-2.2-1.4-3-2.5 c-0.4-0.6-0.7-1.2-1.1-1.8c-1.2-1.7-2.9-2.3-4.9-1.9c-1.3,0.2-2.4,0.7-3.6,1.3c-2.5,1.2-5,1.2-7.4-0.1c-1.1-0.6-2.3-1.1-3.4-1.6 c-2.1-0.8-4.1-0.7-5.9,0.8c-0.5,0.4-1,0.8-1.5,1.1c-2.2,1.5-4.6,2-7.2,1.2c-0.8-0.2-1.6-0.5-2.5-0.6v-0.9C0,24.5,1.2,24,2.3,23.3 c1.4-0.9,2.5-2.1,3.6-3.2c1.3-1.2,2.8-2.2,4.5-2.7c2.7-0.6,5.2-0.3,7.8,0.6c1.7,0.6,3.4,1.4,5.2,1.8c2.1,0.4,4,0.2,5.7-1.2 c1.6-1.2,2.2-2.9,2.3-4.9c0.2-3.7-1-6.7-4.2-8.6c-1.6-1-3.3-1.7-4.9-2.6c-2.5-1.4-4.7-3.2-6.2-5.8c-0.4-0.7-0.8-1.4-0.9-2.3h4.7 c0.5,1.1,1.2,2,2.2,2.8C23.4-1.6,25-1,26.5-0.2c1.1,0.5,2.2,1.1,3.1,2c1.9,1.8,2.9,4,3.5,6.5c0.7,2.7,0.8,5.5,0.7,8.3 c0,0.5-0.1,1,0,1.4c0.1,1,0.7,1.6,1.5,2.2c0.9,0.6,1.9,1.2,2.9,1.9c1.1,0.7,1.7,1.7,2,3c0.1,0.4,0.2,0.7,0.3,1.1 c0.5,2,1.4,2.8,3.5,3c1.1,0.1,2.3,0,3.4,0c2.2,0,3.9,1,5.1,2.9c0.7,1.1,1.1,2.3,1.4,3.5c0.4,2.2,1,4.3,2,6.2 c2.9,5.4,9.4,7.1,14.5,3.6c2.5-1.7,4.1-4.2,5.4-6.9c1.2-2.8,1.8-5.8,2.3-8.8c0.5-3.5,0.8-7,0.3-10.5c-0.6-4.5-2.6-8.1-6.6-10.6 c-2.3-1.4-4.7-2.8-7.1-4.2c-1.8-1-3.6-2-5.1-3.4C57.6-0.8,56.7-2.9,56.9-5.5L56.9-5.5z"
        />
        <path
          className="st2"
          d="M53.2-5.5c0.2,1.2,0.3,2.4,0.6,3.6c1.4,5.6,4.8,9.2,10.6,10.4c2.3,0.5,4.6,1.2,6.4,2.7 c1.8,1.5,3.1,3.4,3.7,5.7c0.6,2.4,0.2,4.6-1.4,6.6c-0.6,0.7-1.2,1.5-1.8,2.2c-1,1.2-1.4,2.7-1.4,4.2c0,1.7,0.1,3.4-0.3,5.1 c-0.3,1.4-0.7,2.7-1.6,3.9c-1.7,2.3-4.6,2.7-6.8,1c-1.7-1.3-2.7-3-3.6-4.9c-1-2-1.8-4.1-3.3-5.8c-1.3-1.6-2.9-2.9-5-3.3 c-0.9-0.2-1.8-0.2-2.8-0.3c-1.3-0.1-2.4-0.6-3.3-1.6c-2.9-3-4.6-6.5-4.2-10.8c0.1-1.2,0.4-2.3,0.7-3.4c0.2-0.7,0.4-1.4,0.6-2.1 c0.3-1.9-0.3-3.3-1.8-4.4c-0.9-0.7-1.9-1.3-2.9-1.8c-1.7-1-3-2.4-3.9-4.2c-0.4-0.9-0.8-1.8-0.7-2.8h7.5c0,0.4,0.2,0.8,0.3,1.2 c0.7,1.9,2,3.3,3.4,4.7c1,0.9,2,1.8,2.9,2.8C46.9,5,47.5,7,47.2,9.3c-0.3,1.8-0.9,3.6-1.3,5.4c-0.7,2.8,0.1,4.8,2.7,6.3 c0.9,0.5,1.8,0.9,2.8,1.2c3.1,1.2,5.6,3.1,7.5,5.8c0.9,1.2,1.5,2.5,2.3,3.8c0.7,1,1.4,2.1,2.4,2.8c1.3,0.9,2.5,0.8,3.5-0.3 c0.6-0.6,0.9-1.4,1-2.2c0.2-1.6-0.3-3.2-0.9-4.6c-0.5-1.2-1.1-2.3-1.6-3.4c-1.2-2.5-0.9-3.9,0.8-5.7c0.6-0.6,1.2-1.2,1.6-1.9 c0.8-1.6,0.3-3.1-1.4-3.9c-1-0.5-2.2-0.6-3.3-0.5c-2.1,0.2-4.3,0.4-6.4,0.2c-2.4-0.3-3.3-1.4-3.1-3.7c0.1-1.2,0.4-2.4,0.4-3.6 c0.1-2.5-0.9-4.4-3.2-5.6c-0.6-0.3-1.1-0.6-1.7-0.9c-1.6-0.8-2.3-2.1-2.1-3.8L53.2-5.5L53.2-5.5z"
        />
        <path
          className="st2"
          d="M-1.3,28.7c1.1,0.8,2.3,1.5,3.7,1.6c1.6,0.1,3.2,0,4.8-0.4c0.7-0.2,1.2-0.5,1.8-0.9c0.5-0.4,1-0.8,1.5-1.2 c1.9-1.5,4-1.7,6.2-1c1.1,0.4,1.9,1.2,2.5,2.2c0.5,0.8,0.8,1.7,1.2,2.6c0.5,1.1,1.1,2.1,2.1,2.9c1.6,1.3,3.3,1.4,5.2,1.1 c3.5-0.5,7-1.2,10.5-1.7c1.4-0.2,2.8-0.3,4.2,0c1.3,0.3,2.4,0.9,3.2,1.8c1.4,1.5,1.4,3.3,0,4.8c-1.5,1.6-3.4,2.2-5.5,2.4 c-1.4,0.1-2.8,0.1-4.1,0.1c-3.6-0.1-6.5,1.3-8.6,4.3c-0.8,1.1-1.7,2.2-2.6,3.2c-2.2,2.3-4.8,2.7-7.8,1.7c-1.5-0.5-2.9-1.4-4.2-2.2 c-2.5-1.6-5.3-2.2-8.2-1.6c-1.2,0.2-2.2,0.7-3.4,1.1c-0.8,0.3-1.6,0.7-2.4,0.8v-5c1.2-0.3,2.2-0.8,3.2-1.4 c1.3-0.8,2.5-1.6,3.9-2.1c3.2-1.3,6.1-1,8.5,1.6c0.9,1,1.9,2.1,2.9,3.1c1.5,1.6,2.9,1.7,4.7,0.4c1.5-1.1,3-2.2,4.6-3.1 c0.7-0.4,1.3-0.9,1.7-1.5c0.7-1.2,0.1-2.4-1.3-2.4c-0.6,0-1.3,0-2,0.1c-3,0.2-5.4-0.9-7.1-3.3c-0.5-0.7-1.1-1.4-1.7-2 c-1.2-1.2-2.7-1.6-4.4-1.3c-1,0.2-2,0.6-3,0.9c-3.3,1-6.4,1.1-9.3-1c-0.2-0.1-0.3-0.3-0.5-0.2V28.7L-1.3,28.7z"
        />
        <path
          className="st2"
          d="M-1.3,22.1V11.7c0.3-0.1,0.5-0.3,0.8-0.5c0.7-0.7,1.3-1.5,1.8-2.3c0.7-1.1,1.6-1.9,2.8-2.4 C4.4,6.3,4.7,6.1,4.9,6c0.8-0.4,1.6-0.9,2-1.8c1-2,0.1-4.9-1.9-6C4.3-2.3,3.4-2.5,2.5-2.6C1.2-2.8,0-2.6-1.3-2.7 c0-0.8,0-1.6,0-2.4c0-0.3,0.1-0.4,0.4-0.4c3.6,0,7.3,0,10.9,0c-0.3,1.4,0.2,2.6,0.9,3.7c1.5,2.2,3.4,3.8,5.7,5.2 c1.9,1.2,4.1,2,6.1,2.9c1.6,0.7,3.3,1.4,4.7,2.5c1.6,1.3,2.2,3,1.6,4.7c-0.9,2.6-4,4-6.3,1.5c-0.2-0.2-0.4-0.4-0.5-0.6 c-1.5-1.6-3.2-2.9-5-4c-2-1.2-4.2-2-6.7-1.9c-1.7,0.1-2.9,0.8-3.8,2.2c-0.7,1.2-1,2.5-1.3,3.8c-0.3,1.2-0.5,2.4-1.1,3.5 C3.1,20.4,1.3,21.9-1.3,22.1L-1.3,22.1z"
        />
        <g>
          <path
            className="st3"
            d="M6.8,20.3L7,9.9c0-0.1,0.1-0.2,0.2-0.3l0.4,0c0.2,0,0.3,0.1,0.3,0.3L7.3,20.3c0,0.2-0.3,0.3-0.5,0.1 C6.8,20.4,6.8,20.4,6.8,20.3L6.8,20.3z"
          />
          <g>
            <path
              className="st4"
              d="M6.8,20.3L7,9.9c0-0.1,0.1-0.2,0.2-0.3l0.4,0c0.2,0,0.3,0.1,0.3,0.3L7.3,20.3c0,0.2-0.3,0.3-0.5,0.1 C6.8,20.4,6.8,20.4,6.8,20.3L6.8,20.3z"
            />
            <path
              className="st3"
              d="M7.2,20.5l4.8-9c0.1-0.1,0-0.2-0.1-0.3l-0.3-0.2c-0.1-0.1-0.3,0-0.4,0.1l-4.5,9.2c-0.1,0.2,0.1,0.4,0.3,0.4 l0,0C7.1,20.6,7.2,20.5,7.2,20.5L7.2,20.5z"
            />
          </g>
          <path
            className="st5"
            d="M9.9,19.7c0.3,0.4,0,1-0.5,1c-0.2,0-0.4-0.1-0.5-0.2l-0.7-0.9L9,18.5L9.9,19.7z"
          />
          <g>
            <path
              className="st6"
              d="M32.3,12.2c0.5,0,1.2,0.4,1.2,1c0,0.9-1.2,1.6-1.2,1.6s-1.2-0.7-1.2-1.6C31.1,12.7,31.7,12.2,32.3,12.2z"
            />
            <path
              className="st5"
              d="M31.7,13c0.2-0.3,0.5,0,0.6,0.2c0.1-0.2,0.4-0.6,0.6-0.2c0.2,0.3-0.3,0.8-0.6,1.1 C32,13.8,31.5,13.3,31.7,13z"
            />
          </g>
          <g>
            <path
              className="st5"
              d="M1.6,18.3c0-1.4,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.4C2.7,20.7,1.6,19.7,1.6,18.3z M5.4,18.3c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4C4.8,19.7,5.4,19.1,5.4,18.3z"
            />
            <path
              className="st5"
              d="M13.2,18.1l-1.8,2.5h-0.8V16h1.1v2.5l1.8-2.5h0.8v4.7h-1.1V18.1z"
            />
            <path
              className="st5"
              d="M19.2,19.7v1.9h-1.1v-0.9h-2.3v0.9h-1.1v-1.9h0.5c0.2-0.3,0.4-0.8,0.4-1.6V16h3.1v3.7H19.2z M17.6,19.7V17 h-1v1.1c0,0.8-0.1,1.2-0.3,1.5H17.6z"
            />
            <path
              className="st5"
              d="M19.5,18.3c0-1.4,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.4 C20.6,20.8,19.5,19.7,19.5,18.3z M23.3,18.3c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4 C22.7,19.7,23.3,19.2,23.3,18.3z"
            />
            <path
              className="st5"
              d="M27.6,20.7l-1.5-2.2v2.2H25V16h1.1v2l1.4-2h1.2l-1.6,2.3l1.6,2.4H27.6z"
            />
            <path
              className="st5"
              d="M31.8,18.1L30,20.7h-0.8V16h1.1v2.5l1.8-2.5h0.8v4.7h-1.1V18.1z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const CoinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8} height={11} fill="none">
    <path
      fill="#fff"
      d="M4 1.45c2.21 0 4 1.813 4 4.05S6.21 9.55 4 9.55 0 7.737 0 5.5s1.79-4.05 4-4.05ZM2.363 4.707c-.619 0-1.129.496-1.129 1.108 0 .612.51 1.109 1.13 1.109a1.107 1.107 0 1 0 0-2.217Zm1.66-.606a.342.342 0 0 0-.342.341v2.14a.342.342 0 0 0 .684 0v-.559l.625.784a.312.312 0 0 0 .498-.375l-.472-.67.42-.55a.272.272 0 1 0-.434-.328l-.637.845V4.442a.342.342 0 0 0-.343-.341Zm2.087.675a.31.31 0 0 0-.307.312v1.524a.31.31 0 0 0 .307.312.31.31 0 0 0 .309-.312V5.088a.31.31 0 0 0-.309-.312Zm-3.747.52c.267 0 .48.232.48.52 0 .287-.213.519-.48.519a.513.513 0 0 1-.496-.52c0-.287.23-.519.496-.52Zm4.22-1.577c-.15-.287-.361.015-.456.185-.095-.17-.314-.472-.464-.185-.15.288.239.699.46.875.221-.176.61-.587.46-.875Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={0.9}
      d="M4 1.45V1M4 10v-.45"
    />
  </svg>
)

export const Cart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M10.8 17.701c0 2.304 1.896 4.2 4.2 4.2 2.304 0 4.2-1.896 4.2-4.2M11.171 3 6.827 7.358M18.828 3l4.344 4.357"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M2.998 10.02c0-2.22 1.188-2.4 2.664-2.4h18.672c1.476 0 2.664.18 2.664 2.4 0 2.58-1.188 2.4-2.664 2.4H5.662c-1.476 0-2.664.18-2.664-2.4Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4.799 12.601 6.49 22.97c.384 2.328 1.308 4.032 4.74 4.032h7.236c3.732 0 4.284-1.632 4.716-3.888l2.016-10.512"
    />
  </svg>
)

export const Home = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29} height={30} fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.505}
      d="M14.508 22.2v-3.6M12.183 3.984l-8.344 6.66c-.939.744-1.54 2.316-1.336 3.492l1.601 9.552c.29 1.704 1.927 3.084 3.66 3.084H21.25c1.722 0 3.371-1.392 3.66-3.084l1.601-9.552c.193-1.176-.41-2.748-1.336-3.492L16.83 3.996c-1.288-1.032-3.37-1.032-4.647-.012Z"
    />
  </svg>
)

export const Herth = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={24} fill="none">
    <path
      stroke="#AEAEAE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.505}
      d="M14.06 22.572c-.41.144-1.084.144-1.493 0C9.075 21.384 1.273 16.428 1.273 8.028c0-3.708 2.998-6.708 6.695-6.708a6.647 6.647 0 0 1 5.345 2.688A6.665 6.665 0 0 1 18.66 1.32c3.696 0 6.694 3 6.694 6.708 0 8.4-7.802 13.356-11.293 14.544Z"
    />
  </svg>
)

export const Feedback = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="none">
    <path
      stroke="#AEAEAE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.505}
      d="M26.92 12.6v3.6c0 4.8-2.408 7.2-7.224 7.2h-.601c-.374 0-.735.18-.964.48l-1.806 2.4c-.794 1.056-2.095 1.056-2.89 0l-1.805-2.4c-.193-.264-.638-.48-.963-.48h-.602c-4.816 0-7.224-1.2-7.224-7.2v-6c0-4.8 2.408-7.2 7.224-7.2h7.224"
    />
    <path
      stroke="#AEAEAE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.806}
      d="M19.692 13.8h.01M14.876 13.8h.01M10.058 13.8h.011"
    />
    <ellipse cx={24.513} cy={5.4} fill="#A6DD2F" rx={4.816} ry={4.8} />
  </svg>
)

export const Box = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M3.16992 7.43994L11.9999 12.5499L20.7699 7.46991" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M12 21.61V12.54" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M9.9306 2.48L4.59061 5.45003C3.38061 6.12003 2.39062 7.80001 2.39062 9.18001V14.83C2.39062 16.21 3.38061 17.89 4.59061 18.56L9.9306 21.53C11.0706 22.16 12.9406 22.16 14.0806 21.53L19.4206 18.56C20.6306 17.89 21.6206 16.21 21.6206 14.83V9.18001C21.6206 7.80001 20.6306 6.12003 19.4206 5.45003L14.0806 2.48C12.9306 1.84 11.0706 1.84 9.9306 2.48Z" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M16.9998 13.2401V9.58014L7.50977 4.1001" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const Convert = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M2 9C2 5.13 5.13 2 9 2L7.95 3.75" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M13.6992 4.4502L17.6792 6.75018L21.6192 4.46021" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M17.6797 10.8203V6.74023" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M16.7396 2.21L14.3396 3.53996C13.7996 3.83996 13.3496 4.59995 13.3496 5.21995V7.75999C13.3496 8.37999 13.7896 9.13998 14.3396 9.43998L16.7396 10.77C17.2496 11.06 18.0896 11.06 18.6096 10.77L21.0096 9.43998C21.5496 9.13998 21.9996 8.37999 21.9996 7.75999V5.21995C21.9996 4.59995 21.5596 3.83996 21.0096 3.53996L18.6096 2.21C18.0996 1.93 17.2596 1.93 16.7396 2.21Z" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M2.34961 15.4502L6.31961 17.7502L10.2696 15.4602" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M6.32031 21.8203V17.7402" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M5.39 13.21L2.99001 14.54C2.45001 14.84 2 15.5999 2 16.2199V18.76C2 19.38 2.44001 20.14 2.99001 20.44L5.39 21.77C5.9 22.06 6.73999 22.06 7.25999 21.77L9.66 20.44C10.2 20.14 10.65 19.38 10.65 18.76V16.2199C10.65 15.5999 10.21 14.84 9.66 14.54L7.25999 13.21C6.73999 12.93 5.9 12.93 5.39 13.21Z" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const Wallet = () => (
  <svg 
    width="21" 
    height="21" 
    viewBox="0 0 21 21" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.39284 7.01816C2.78007 7.01816 1.46103 8.33721 1.46103 9.94998V16.5051C1.46103 18.1179 2.78007 19.437 4.39284 19.437H15.5746C17.1874 19.437 18.5064 18.1179 18.5064 16.5051V16.0766H17.3863C16.0134 16.0766 14.6808 15.0726 14.5548 13.5896C14.4761 12.7498 14.7959 11.9653 15.3499 11.4207C15.8483 10.9125 16.5315 10.6221 17.2694 10.6221H18.5064V9.94998C18.5064 8.33721 17.1874 7.01816 15.5746 7.01816H4.39284ZM0 9.94998C0 7.5303 1.97316 5.55713 4.39284 5.55713H15.5746C17.9943 5.55713 19.9675 7.5303 19.9675 9.94998V11.3526C19.9675 11.756 19.6404 12.0831 19.237 12.0831H17.2694C16.9197 12.0831 16.6121 12.2187 16.3902 12.4466L16.3771 12.4597C16.118 12.7127 15.9732 13.0729 16.0096 13.4554L16.0105 13.464L16.0104 13.464C16.062 14.0825 16.6567 14.6155 17.3863 14.6155H19.237C19.6404 14.6155 19.9675 14.9426 19.9675 15.346V16.5051C19.9675 18.9248 17.9943 20.898 15.5746 20.898H4.39284C1.97316 20.898 0 18.9248 0 16.5051V9.94998Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M12.0292 2.58611C12.0292 1.79957 11.2431 1.25959 10.5154 1.53542L2.78124 4.45763C1.98569 4.75881 1.46103 5.51837 1.46103 6.37508V10.8263C1.46103 11.2298 1.13397 11.5568 0.730517 11.5568C0.327064 11.5568 0 11.2298 0 10.8263V6.37508C0 4.91373 0.897598 3.60824 2.26419 3.09115L9.99754 0.169229C9.9974 0.169283 9.99769 0.169176 9.99754 0.169229C11.6853 -0.47015 13.4902 0.781908 13.4902 2.58611V6.28739C13.4902 6.69084 13.1632 7.01791 12.7597 7.01791C12.3562 7.01791 12.0292 6.69084 12.0292 6.28739V2.58611Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M17.2694 12.0829C16.9197 12.0829 16.6121 12.2185 16.3902 12.4464L16.3771 12.4595C16.118 12.7124 15.9732 13.0726 16.0096 13.4551L16.0105 13.4637L16.0104 13.4637C16.0619 14.0822 16.6567 14.6153 17.3863 14.6153H19.2786C19.436 14.6051 19.5389 14.482 19.5389 14.3524V12.3458C19.5389 12.2161 19.436 12.093 19.2786 12.0829H17.2694ZM15.3499 11.4205C15.8482 10.9122 16.5314 10.6218 17.2694 10.6218H19.2954C19.3041 10.6218 19.3128 10.622 19.3215 10.6223C20.2497 10.6554 20.9999 11.4066 20.9999 12.3458V14.3524C20.9999 15.2916 20.2497 16.0427 19.3215 16.0759C19.3128 16.0762 19.3041 16.0763 19.2954 16.0763H17.3863C16.0134 16.0763 14.6808 15.0724 14.5548 13.5894C14.4761 12.7496 14.7959 11.965 15.3499 11.4205Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.38281 10.4271C4.38281 10.0236 4.70988 9.69653 5.11333 9.69653H11.9315C12.3349 9.69653 12.662 10.0236 12.662 10.4271C12.662 10.8305 12.3349 11.1576 11.9315 11.1576H5.11333C4.70988 11.1576 4.38281 10.8305 4.38281 10.4271Z" 
      fill="#5A91FF"
    />
  </svg>
);

export const WalletTransfer = () => (
  <svg 
    width="28" 
    height="25" 
    viewBox="0 0 28 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M16.3005 4.19368L14.3595 2.68119L15.8732 0.75009" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.39284 10.6124C2.78007 10.6124 1.46103 11.9314 1.46103 13.5442V20.0994C1.46103 21.7122 2.78007 23.0312 4.39284 23.0312H15.5746C17.1874 23.0312 18.5064 21.7122 18.5064 20.0994V19.6708H17.3863C16.0134 19.6708 14.6808 18.6669 14.5548 17.1838C14.4761 16.344 14.7959 15.5595 15.3499 15.0149C15.8483 14.5067 16.5315 14.2163 17.2694 14.2163H18.5064V13.5442C18.5064 11.9314 17.1874 10.6124 15.5746 10.6124H4.39284ZM0 13.5442C0 11.1245 1.97316 9.15137 4.39284 9.15137H15.5746C17.9943 9.15137 19.9675 11.1245 19.9675 13.5442V14.9468C19.9675 15.3503 19.6404 15.6773 19.237 15.6773H17.2694C16.9197 15.6773 16.6121 15.8129 16.3902 16.0408L16.3771 16.0539C16.118 16.3069 15.9732 16.6671 16.0096 17.0496L16.0105 17.0582L16.0104 17.0582C16.062 17.6767 16.6567 18.2098 17.3863 18.2098H19.237C19.6404 18.2098 19.9675 18.5368 19.9675 18.9403V20.0994C19.9675 22.5191 17.9943 24.4922 15.5746 24.4922H4.39284C1.97316 24.4922 0 22.5191 0 20.0994V13.5442Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M12.0292 6.18035C12.0292 5.39381 11.2431 4.85382 10.5154 5.12966L2.78124 8.05187C1.98569 8.35305 1.46103 9.1126 1.46103 9.96931V14.4205C1.46103 14.824 1.13397 15.1511 0.730517 15.1511C0.327064 15.1511 0 14.824 0 14.4205V9.96931C0 8.50797 0.897598 7.20248 2.26419 6.68539L9.99754 3.76347C9.9974 3.76352 9.99769 3.76341 9.99754 3.76347C11.6853 3.12409 13.4902 4.37615 13.4902 6.18035V9.88163C13.4902 10.2851 13.1632 10.6121 12.7597 10.6121C12.3562 10.6121 12.0292 10.2851 12.0292 9.88163V6.18035Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M17.2694 15.6769C16.9197 15.6769 16.6121 15.8125 16.3902 16.0403L16.3771 16.0535C16.118 16.3064 15.9732 16.6666 16.0096 17.0491L16.0105 17.0577L16.0104 17.0577C16.0619 17.6762 16.6567 18.2093 17.3863 18.2093H19.2786C19.436 18.1991 19.5389 18.076 19.5389 17.9463V15.9398C19.5389 15.8101 19.436 15.687 19.2786 15.6769H17.2694ZM15.3499 15.0145C15.8482 14.5062 16.5314 14.2158 17.2694 14.2158H19.2954C19.3041 14.2158 19.3128 14.216 19.3215 14.2163C20.2497 14.2494 20.9999 15.0006 20.9999 15.9398V17.9463C20.9999 18.8856 20.2497 19.6367 19.3215 19.6699C19.3128 19.6702 19.3041 19.6703 19.2954 19.6703H17.3863C16.0134 19.6703 14.6808 18.6664 14.5548 17.1834C14.4761 16.3436 14.7959 15.559 15.3499 15.0145Z" 
      fill="#5A91FF"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.38281 14.0215C4.38281 13.6181 4.70988 13.291 5.11333 13.291H11.9315C12.3349 13.291 12.662 13.6181 12.662 14.0215C12.662 14.425 12.3349 14.752 11.9315 14.752H5.11333C4.70988 14.752 4.38281 14.425 4.38281 14.0215Z" 
      fill="#5A91FF"
    />
    <path 
      d="M14.3613 2.69141L16.6637 2.40572C21.7447 1.77523 26.3642 5.38384 26.9935 10.4549C27.3531 13.3527 26.3248 16.1103 24.4402 18.0572" 
      stroke="#5A91FF" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const AdresMap = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 9.00002V15C22 17.5 21.5 19.25 20.38 20.38L14 14L21.73 6.27002C21.91 7.06002 22 7.96002 22 9.00002Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3795 20.38C19.2495 21.5 17.4995 22 14.9995 22H8.99954C7.95954 22 7.05953 21.91 6.26953 21.73L13.9995 14L20.3795 20.38Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.23929 7.97997C6.91929 5.04997 11.3193 5.04997 11.9993 7.97997C12.3893 9.69997 11.3093 11.16 10.3593 12.06C9.66928 12.72 8.5793 12.72 7.8793 12.06C6.9293 11.16 5.83929 9.69997 6.23929 7.97997Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
    />
    <path
      d="M9.09412 8.69995H9.1031"
      stroke="#5A91FF"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Routing = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.72537 3.8334C2.39204 0.950065 6.73371 0.950065 7.39204 3.8334C7.78371 5.52507 6.70871 6.9584 5.77537 7.85007C5.09204 8.50007 4.01704 8.49173 3.33371 7.85007C2.40871 6.9584 1.33371 5.52507 1.72537 3.8334Z"
      stroke="white"
      strokeWidth={1.25}
    />
    <path
      d="M12.5593 13.8334C13.226 10.9501 17.5926 10.9501 18.2593 13.8334C18.651 15.5251 17.576 16.9584 16.6343 17.8501C15.951 18.5001 14.8676 18.4917 14.1843 17.8501C13.2426 16.9584 12.1676 15.5251 12.5593 13.8334Z"
      stroke="white"
      strokeWidth={1.25}
    />
    <path
      d="M9.99942 4.1665H12.2328C13.7744 4.1665 14.4911 6.07484 13.3328 7.0915L6.67443 12.9165C5.51609 13.9248 6.23276 15.8332 7.76609 15.8332H9.99942"
      stroke="white"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.57111 4.58317H4.58074"
      stroke="white"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4051 14.5832H15.4147"
      stroke="white"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Phone = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 9C22 5.13 18.87 2 15 2"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Mail = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 10.5V15.5C22 19 20 20.5 17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H14"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 9L10.13 11.5C11.16 12.32 12.85 12.32 13.88 11.5L15.06 10.56"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 8C20.8807 8 22 6.88071 22 5.5C22 4.11929 20.8807 3 19.5 3C18.1193 3 17 4.11929 17 5.5C17 6.88071 18.1193 8 19.5 8Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditBlue = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2594 3.60022L5.04936 12.2902C4.73936 12.6202 4.43936 13.2702 4.37936 13.7202L4.00936 16.9602C3.87936 18.1302 4.71936 18.9302 5.87936 18.7302L9.09936 18.1802C9.54936 18.1002 10.1794 17.7702 10.4894 17.4302L18.6994 8.74022C20.1194 7.24022 20.7594 5.53022 18.5494 3.44022C16.3494 1.37022 14.6794 2.10022 13.2594 3.60022Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5C12.43 7.76 14.67 9.87 17.45 10.15"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 22H21"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Clipboard = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12.2002H15"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16.2002H12.38"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Building = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5007 22.0003H4.0807C2.9207 22.0003 1.9707 21.0703 1.9707 19.9303V5.09035C1.9707 2.47035 3.9207 1.28035 6.3107 2.45035L10.7507 4.63035C11.7107 5.10035 12.5007 6.35035 12.5007 7.41035V22.0003Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.97 15.0599V18.8399C21.97 20.9999 20.97 21.9999 18.81 21.9999H12.5V10.4199L12.97 10.5199L17.47 11.5299L19.5 11.9799C20.82 12.2699 21.9 12.9499 21.96 14.8699C21.97 14.9299 21.97 14.9899 21.97 15.0599Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 9H8.97"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 13H8.97"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4707 11.53V14.75C17.4707 15.99 16.4607 17 15.2207 17C13.9807 17 12.9707 15.99 12.9707 14.75V10.52L17.4707 11.53Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9607 14.8703C21.9007 16.0503 20.9207 17.0003 19.7207 17.0003C18.4807 17.0003 17.4707 15.9903 17.4707 14.7503V11.5303L19.5007 11.9803C20.8207 12.2703 21.9007 12.9503 21.9607 14.8703Z"
      stroke="#5A91FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);